export enum TaskStatus {
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
  IN_PROGRESS = 'IN PROGRESS',
  DELETED = 'DELETED',
}

export const TaskStatusColors: Record<TaskStatus, string> = {
  [TaskStatus.OPENED]: 'green',
  [TaskStatus.CLOSED]: 'gray',
  [TaskStatus.IN_PROGRESS]: 'purple',
  [TaskStatus.DELETED]: 'white',
};
